import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as jobTitle from '../job-title'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: jobTitle.RESOURCE.payload.dimension.partialId,
      partialId: jobTitle.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Useful for identifying distinct job titles that serve the same function',
    isOptional: true,
    name: 'Type',
    partialId: PartialId.Standard.create('type'),
    type: {
      enumId: core.dms.models.Enum.Id.from(enums.jobType.RESOURCE.payload),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
